import { useTranslation } from "react-i18next";

import type { IErrorViewProps } from "./types";
import classes from "./styles.module.scss";

import { Typography } from "@/components/atoms/typography";
import { backErrors, frontErrors } from "@/templates/errors/view/helper";

export function RenderErrorContent(props: IErrorViewProps) {
  const { errorCode, isFront } = props;

  const { t } = useTranslation("error");

  const errors = isFront ? frontErrors : backErrors;

  return (
    <div className={classes.container__content}>
      <div className={classes.container__content__title}>
        <Typography fontType={"title-h6"} themeColor={"text-strong-900"}>
          {t(errors[errorCode].title)}
        </Typography>
        <Typography
          fontType={"paragraph-medium"}
          themeColor={"text-sub-600"}
          className={classes.container__content__des}
        >
          {t(errors[errorCode].description)}
        </Typography>
      </div>
      {errors[errorCode].button}
    </div>
  );
}
